<div class="content">
  <div class="row align-items-center mb-4">
    <div class="col-sm-6">
      <h6 class="fw-medium d-inline-flex align-items-center mb-3 mb-sm-0">
        <!-- <a [routerLink]="['/company/business', officeDetail?.businessId]"> -->
        <a href="javascript:void(0);" (click)="goBack()">
          <i class="ti ti-arrow-left me-2"></i>Business :
          {{ officeDetail?.business?.businessName }}</a
        >
        <span class="text-gray d-inline-flex ms-2">/ Office: {{ officeDetail?.officeName }}</span>
      </h6>
    </div>
    <div class="col-sm-6 d-none">
      <div class="d-flex align-items-center justify-content-sm-end">
        <a
          href="javascript:void(0);"
          class="btn btn-primary d-inline-flex align-items-center me-2"
          data-bs-toggle="modal"
          data-bs-target="#add_deals"
        >
          <i class="ti ti-circle-plus me-2"></i>Add Deal
        </a>
        <a href="javascript:void(0);" class="btn btn-dark d-inline-flex align-items-center"
          ><i class="ti ti-mail me-2"></i>Send Email</a
        >
        <div class="head-icons ms-2 mb-0">
          <a
            href="javascript:void(0);"
            class=""
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-original-title="Collapse"
            id="collapse-header"
          >
            <i class="ti ti-chevrons-up"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xl-4 theiaStickySidebar">
      <div class="card card-bg-1">
        <div class="card-body p-0">
          <!-- <span class="avatar avatar-xl border bg-white rounded-circle m-auto d-flex mb-2">
              <img [src]="apiEndpoint + businessDetail.picture" class="w-auto h-auto" alt="Img">
            </span> -->
          <div class="text-center px-3 pb-3 border-bottom mt-5">
            <h5 class="d-flex align-items-center justify-content-center mb-1">
              {{ officeDetail?.officeName }}
              <i class="ti ti-discount-check-filled text-success ms-1"></i>
            </h5>
            <p class="text-dark">
              {{ officeDetail?.address }}
              {{ officeDetail?.city ? ', ' + officeDetail?.city?.name : '' }}
              {{ officeDetail?.city?.state ? ', ' + officeDetail?.city?.state?.name : '' }}
              {{ officeDetail?.city?.country ? ', ' + officeDetail?.city?.country?.name : '' }}
              {{ officeDetail?.zipCode ? ', ' + officeDetail?.zipCode : '' }}
            </p>
          </div>
          <div class="p-3 border-bottom">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <h6>Basic information</h6>
              <a
                href="javascript:void(0);"
                class="btn btn-icon btn-sm"
                (click)="openBusiness(updateOfficeModal); SetupdateOffice(officeDetail)"
                *appHasPermission="{ office: ['edit'] }"
                ><i class="ti ti-edit"></i
              ></a>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-business me-2"></i>
                Business Entity
              </span>
              <p class="text-dark">{{ officeDetail?.business?.businessName }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-user me-2"></i>
                Business Entity Owner
              </span>
              <p class="text-dark">{{ officeDetail?.business?.user.name }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-gender-male me-2"></i>
                Created On
              </span>
              <p class="text-dark">{{ createdAt | date: 'medium' }}</p>
            </div>
          </div>
          <div class="p-3 border-bottom">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <h6>Other Information <span class="text-danger"> *</span></h6>
              <a
                href="javascript:void(0);"
                class="btn btn-icon btn-sm"
                *appHasPermission="{ office: ['edit'] }"
                ><i class="ti ti-edit"></i
              ></a>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-e-passport me-2"></i>
                Language
              </span>
              <p class="text-dark">English</p>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-mail-check me-2"></i>
                Currency
              </span>
              <p class="text-dark">United States dollar</p>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-globe me-2"></i>
                Last Modified
              </span>
              <p class="text-dark">{{ updatedAt | date: 'medium' }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-bookmark-plus me-2"></i>
                Source
              </span>
              <p class="text-dark">Website</p>
            </div>
          </div>
          <div class="p-3 border-bottom d-none">
            <h5 class="mb-3">Tags</h5>
            <div class="d-flex align-items-center">
              <span class="badge badge-soft-success me-3">Collab</span>
              <span class="badge badge-soft-warning">Rated</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-8">
      <div>
        <div class="bg-white rounded">
          <ul class="nav nav-tabs nav-tabs-bottom nav-justified flex-wrap mb-3" role="tablist">
            <li class="nav-item" role="presentation" *appHasPermission="{ employees: ['view'] }">
              <a
                class="nav-link active fw-medium d-flex align-items-center justify-content-center"
                href="#bottom-justified-tab6"
                data-bs-toggle="tab"
                aria-selected="false"
                role="tab"
              >
                <i class="ti ti-users me-1"></i>
                Employees
              </a>
            </li>
            <li class="nav-item" role="presentation">
              <a
                class="nav-link fw-medium d-flex align-items-center justify-content-center"
                href="#bottom-justified-tab1"
                data-bs-toggle="tab"
                aria-selected="false"
                role="tab"
              >
                <i class="ti ti-activity me-1"></i>
                Activities <span class="text-danger">*</span>
              </a>
            </li>
            <li class="nav-item" role="presentation">
              <a
                class="nav-link fw-medium d-flex align-items-center justify-content-center"
                href="#bottom-justified-tab2"
                data-bs-toggle="tab"
                aria-selected="false"
                role="tab"
              >
                <i class="ti ti-file-description me-1"></i>
                Notes <span class="text-danger">*</span>
              </a>
            </li>
            <li class="nav-item" role="presentation">
              <a
                class="nav-link fw-medium d-flex align-items-center justify-content-center"
                href="#bottom-justified-tab3"
                data-bs-toggle="tab"
                aria-selected="true"
                role="tab"
              >
                <i class="ti ti-phone-call me-1"></i>
                Calls <span class="text-danger">*</span>
              </a>
            </li>
            <li class="nav-item" role="presentation">
              <a
                class="nav-link fw-medium d-flex align-items-center justify-content-center"
                href="#bottom-justified-tab4"
                data-bs-toggle="tab"
                aria-selected="true"
                role="tab"
              >
                <i class="ti ti-files me-1"></i>
                Files <span class="text-danger">*</span>
              </a>
            </li>
            <li class="nav-item" role="presentation">
              <a
                class="nav-link fw-medium d-flex align-items-center justify-content-center"
                href="#bottom-justified-tab5"
                data-bs-toggle="tab"
                aria-selected="true"
                role="tab"
              >
                <i class="ti ti-mail-check me-1"></i>
                Email <span class="text-danger">*</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="tab-content">
          <div class="tab-pane active show" id="bottom-justified-tab6" role="tabpanel">
            <div class="card border-0">
              <div class="card-header">
                <div class="d-flex align-items-center justify-content-between">
                  <h5>Employees</h5>
                  <div
                    class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
                  >
                    <!-- <div class="me-3" *ngIf="employeeList?.length > 0">
                      <select
                        class="form-select form-select-sm col-md-1"
                        id="entries"
                        [(ngModel)]="pageLimit"
                        (change)="onPageLimitChange()"
                      >
                        <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">
                          {{ limit }}
                        </option>
                      </select>
                    </div> -->
                    <div class="me-3" *ngIf="employees$ | async as employees">
                      <select
                        data-extension-safe
                        class="form-select form-select-sm col-md-1"
                        id="entries"
                        [(ngModel)]="pageLimit"
                        (change)="onPageLimitChange()"
                      >
                        <!-- <option selected disabled>Show Entries Per Page</option> -->
                        <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">
                          {{ limit }}
                        </option>
                      </select>
                    </div>
                    <div class="dropdown me-3">
                      <select
                        class="form-select"
                        #statusSelect
                        [(ngModel)]="status"
                        (change)="getEmployeeList(); setCurrentPage()"
                      >
                        <option value="" selected>Select Status</option>
                        <option value="false">Active</option>
                        <option value="true">Inactive</option>
                      </select>
                    </div>
                    <div class="form-sort search-box">
                      <label>
                        <input
                          type="search"
                          class="form-control"
                          placeholder="Search"
                          [(ngModel)]="search"
                          (input)="getEmployeeList(); setCurrentPage()"
                      /></label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body p-0">
                <div class="custom-datatable-filter table-responsive">
                  <table class="table datatable" *ngIf="employeeList?.length > 0; else noRecords">
                    <thead class="thead-light">
                      <tr>
                        <!-- <th class="no-sort"></th> -->
                        <th>Name</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <!-- <th>Tags</th>
                          <th>Location</th>
                          <th>Rating</th> -->
                        <!-- <th>Office</th> -->
                        <!-- <th>Business Entity</th>
                          <th>Owner</th> -->
                        <!-- <th>Contact </th> -->
                        <th>Status</th>
                        <th class="text-end">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- <tr *ngFor="let employee of employeeList"> -->
                      <tr *ngFor="let employee of employees$ | async">
                        <!-- <td>
                            <div class="set-star star-select">
                              <i class="fa fa-star filled"></i>
                            </div>
                          </td> -->
                        <td>
                          <!-- <h2 class="table-avatar d-flex align-items-center">
                              <a href="company-details.html" class="avatar"><img [src]="apiEndpoint + employee.user.picture"
                                  alt="User Image"></a>
                              <a href="company-details.html" class="profile-split">{{employee.user.name}}</a>
                            </h2> -->
                          <div class="d-flex align-items-center">
                            <a
                              [routerLink]="[eps.hrm.employeePath, employee.id]"
                              class="avatar avatar-md"
                              data-bs-toggle="modal"
                              data-bs-target="#view_details"
                            >
                              <!-- <img
                                [src]="
                                  employee.picture ? businessImages[employee.picture] : defaultImg
                                "
                                class="img-fluid rounded-circle"
                                alt="img"
                              /> -->
                              <!-- <span
                                class="avatar avatar-md rounded-circle d-inline-flex align-items-center justify-content-center bg-light text-dark fw-bold"
                                style="width: 40px; height: 40px"
                              > -->
                              <ng-container
                                *ngIf="
                                  employee.picture && businessImages[employee.picture];
                                  else initials
                                "
                              >
                                <img
                                  [src]="businessImages[employee.picture]"
                                  (error)="onImageError(employee)"
                                  class="img-fluid rounded-circle"
                                  alt="img"
                                  style="width: 100%; height: 100%; object-fit: cover"
                                />
                              </ng-container>

                              <ng-template #initials>
                                <span
                                  class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold"
                                  style="width: 30px; height: 30px"
                                  >{{ getInitials(employee.firstName, employee.lastName) }}</span
                                >
                              </ng-template>
                              <!-- </span> -->
                            </a>
                            <div class="ms-2">
                              <p class="text-dark mb-0">
                                <a
                                  [routerLink]="[eps.hrm.employeePath, employee.id]"
                                  data-bs-toggle="modal"
                                  data-bs-target="#view_details"
                                  >{{ employee.firstName | capitalize }}
                                  {{ employee.lastName | capitalize }}</a
                                >
                              </p>
                              <span class="fs-12">{{
                                employee.designation?.designationName | capitalize
                              }}</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <a
                            href="mailto:{{ employee.email }}"
                            class="__cf_email__"
                            data-cfemail="4a3825282f383e3925240a2f322b273a262f64292527"
                            >{{ employee.email }}</a
                          >
                        </td>
                        <td>{{ employee.mobile }}</td>

                        <td>
                          <span
                            *ngIf="employee.disabled === false"
                            class="badge badge-success d-inline-flex align-items-center badge-xs"
                          >
                            Active
                          </span>
                          <span
                            *ngIf="employee.disabled === true"
                            class="badge badge-danger d-inline-flex align-items-center badge-xs"
                          >
                            Inactive
                          </span>
                        </td>
                        <td class="text-end">
                          <div class="action-icon d-inline-flex">
                            <a
                              [routerLink]="[eps.hrm.employeePath, employee.id]"
                              class="me-2"
                              *appHasPermission="{ employees: ['view'] }"
                              ><i class="ti ti-eye"></i
                            ></a>
                            <!-- <a href="javascript:void(0);" class="me-2" (click)="openBlockUnblock(blockunblockModal, employee.userId, employee.user.disabled)" *appHasPermission="'status_employee'" ><i [ngClass]="employee.user.disabled == 1 ? 'ti ti-lock' : 'ti ti-lock-open-2'"></i></a>
                              <a href="javascript:void(0);" (click)="openDelete(deleteModal, employee.userId)" *appHasPermission="'delete_employee'"><i class="ti ti-trash"></i></a> -->
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <ng-template #noRecords>
                    <div class="text-center">Record not available</div>
                  </ng-template>
                </div>
              </div>
              <!-- pagination -->
              <div
                class="d-flex align-items-center justify-content-between ms-2"
                *ngIf="employeeList?.length > 0"
              >
                <div>
                  Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
                  {{ totalCount }} entries
                </div>
                <div class="has-text-centered mt-3">
                  <app-pagination
                    [currentPage]="currentPage"
                    [pageSize]="pageLimit"
                    [totalRows]="totalCount"
                    (pageChange)="onPageChange($event)"
                  ></app-pagination>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane" id="bottom-justified-tab1" role="tabpanel">
            <div class="card border-0">
              <div class="card-header">
                <div class="d-flex align-items-center justify-content-between">
                  <h5>Activities</h5>
                  <div class="dropdown">
                    <a
                      href="javascript:void(0);"
                      class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Sort By : Last 7 Days
                    </a>
                    <ul class="dropdown-menu dropdown-menu-end p-3">
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item rounded-1"
                          >Recently Added</a
                        >
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item rounded-1">Ascending</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item rounded-1">Desending</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item rounded-1">Last Month</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item rounded-1"
                          >Last 7 Days</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <span class="badge badge-soft-purple d-inline-flex align-items-center mb-3">
                  <i class="ti ti-calendar me-1"></i>
                  15 Feb 2024
                </span>
                <div class="border rounded p-3 mb-3">
                  <div class="d-flex align-items-start">
                    <span class="avatar avatar-md avatar-rounded flex-shrink-0 bg-skyblue me-2"
                      ><i class="ti ti-message-circle-2 fs-20"></i
                    ></span>
                    <div>
                      <h6 class="fw-medium mb-1">You sent 1 Message to the contact.</h6>
                      <span>10:25 pm</span>
                    </div>
                  </div>
                </div>
                <div class="border rounded p-3 mb-3">
                  <div class="d-flex align-items-start">
                    <span class="avatar avatar-md avatar-rounded bg-success flex-shrink-0 me-2"
                      ><i class="ti ti-phone fs-20"></i
                    ></span>
                    <div>
                      <h6 class="fw-medium mb-1">
                        Denwar responded to your appointment schedule question by call at 09:30pm.
                      </h6>
                      <span>09:25 pm</span>
                    </div>
                  </div>
                </div>
                <div class="border rounded p-3 mb-3">
                  <div class="d-flex align-items-start">
                    <span class="avatar avatar-md avatar-rounded flex-shrink-0 bg-warning me-2"
                      ><i class="ti ti-file-description fs-20"></i
                    ></span>
                    <div>
                      <h6 class="fw-medium mb-1">Notes added by Antony</h6>
                      <p class="mb-1">
                        Please accept my apologies for the inconvenience caused. It would be much
                        appreciated if it's possible to reschedule to 6:00 PM, or any other day that
                        week.
                      </p>
                      <span>10.00 pm</span>
                    </div>
                  </div>
                </div>
                <span class="badge badge-soft-purple d-inline-flex align-items-center mb-3">
                  <i class="ti ti-calendar me-1"></i>
                  15 Feb 2024
                </span>
                <div class="border rounded p-3 mb-3">
                  <div class="d-flex align-items-start">
                    <span class="avatar avatar-md avatar-rounded flex-shrink-0 bg-purple me-2"
                      ><i class="ti ti-user-circle fs-20"></i
                    ></span>
                    <div>
                      <h6 class="fw-medium d-flex align-items-center mb-1">
                        Meeting With
                        <span class="avatar avatar-sm avatar-rounded mx-1"
                          ><img src="assets/img/profiles/avatar-02.jpg" alt="Img"
                        /></span>
                        Abraham
                      </h6>
                      <span>Schedueled on 05:00 pm</span>
                    </div>
                  </div>
                </div>
                <div class="border rounded p-3 mb-3">
                  <div class="d-flex align-items-start">
                    <span class="avatar avatar-md avatar-rounded bg-success flex-shrink-0 me-2"
                      ><i class="ti ti-phone fs-20"></i
                    ></span>
                    <div>
                      <h6 class="fw-medium mb-1">
                        Drain responded to your appointment schedule question.
                      </h6>
                      <span>09:25 pm</span>
                    </div>
                  </div>
                </div>
                <span class="badge badge-soft-purple d-inline-flex align-items-center mb-3">
                  <i class="ti ti-calendar me-1"></i>
                  Upcoming Activity
                </span>
                <div class="border rounded p-3">
                  <div class="d-flex align-items-start mb-2">
                    <span class="avatar avatar-md avatar-rounded flex-shrink-0 bg-purple me-2"
                      ><i class="ti ti-user-circle fs-20"></i
                    ></span>
                    <div>
                      <h6 class="fw-medium mb-1">Product Meeting</h6>
                      <p class="mb-1">
                        A product team meeting is a gathering of the cross-functional product team —
                        ideally including team members from product, engineering, marketing, and
                        customer support.
                      </p>
                      <span>Schedueled on 05:00 pm</span>
                    </div>
                  </div>
                  <div class="bg-light-500 rounded p-3">
                    <div class="row">
                      <div class="col-md-4 col-sm-6">
                        <div>
                          <h6 class="fs-12 fw-medium mb-2">Reminder</h6>
                          <div class="dropdown">
                            <a
                              href="javascript:void(0);"
                              class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                              data-bs-toggle="dropdown"
                            >
                              <i class="clock-hour-3 me-1"></i>
                              Reminder
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end p-3">
                              <li>
                                <a href="javascript:void(0);" class="dropdown-item rounded-1"
                                  >Reminder</a
                                >
                              </li>
                              <li>
                                <a href="javascript:void(0);" class="dropdown-item rounded-1"
                                  >1 Hr</a
                                >
                              </li>
                              <li>
                                <a href="javascript:void(0);" class="dropdown-item rounded-1"
                                  >10 Hr</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 col-sm-6">
                        <div>
                          <h6 class="fs-12 fw-medium mb-2">Task Priority</h6>
                          <div class="dropdown">
                            <a
                              href="javascript:void(0);"
                              class="dropdown-toggle btn-sm btn btn-white d-inline-flex align-items-center"
                              data-bs-toggle="dropdown"
                            >
                              <span
                                class="border border-purple rounded-circle bg-soft-danger d-flex justify-content-center align-items-center me-1"
                              >
                                <i class="ti ti-point-filled text-danger"></i>
                              </span>
                              High
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end p-3">
                              <li>
                                <a href="javascript:void(0);" class="dropdown-item rounded-1"
                                  >High</a
                                >
                              </li>
                              <li>
                                <a href="javascript:void(0);" class="dropdown-item rounded-1"
                                  >Medium</a
                                >
                              </li>
                              <li>
                                <a href="javascript:void(0);" class="dropdown-item rounded-1"
                                  >Low</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 col-sm-6">
                        <div>
                          <h6 class="fs-12 fw-medium mb-2">Assigned to</h6>
                          <div class="dropdown">
                            <a
                              href="javascript:void(0);"
                              class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                              data-bs-toggle="dropdown"
                            >
                              <span class="avatar avatar-xs avatar-rounded me-1">
                                <img src="assets/img/profiles/avatar-02.jpg" alt="Img" />
                              </span>
                              John
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end p-3">
                              <li>
                                <a
                                  href="javascript:void(0);"
                                  class="dropdown-item rounded-1 d-flex align-items-center"
                                >
                                  <span class="avatar avatar-xs avatar-rounded me-1">
                                    <img src="assets/img/profiles/avatar-02.jpg" alt="Img" />
                                  </span>
                                  John
                                </a>
                              </li>
                              <li>
                                <a
                                  href="javascript:void(0);"
                                  class="dropdown-item rounded-1 d-flex align-items-center"
                                >
                                  <span class="avatar avatar-xs avatar-rounded me-1">
                                    <img src="assets/img/profiles/avatar-01.jpg" alt="Img" />
                                  </span>
                                  Sophie
                                </a>
                              </li>
                              <li>
                                <a
                                  href="javascript:void(0);"
                                  class="dropdown-item rounded-1 d-flex align-items-center"
                                >
                                  <span class="avatar avatar-xs avatar-rounded me-1">
                                    <img src="assets/img/profiles/avatar-03.jpg" alt="Img" />
                                  </span>
                                  Estelle
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane" id="bottom-justified-tab2" role="tabpanel">
            <div class="card border-0">
              <div class="card-header">
                <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <h5>Notes</h5>
                  <div class="d-flex align-items-center">
                    <div class="dropdown me-2">
                      <a
                        href="javascript:void(0);"
                        class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        Sort By : Last 7 Days
                      </a>
                      <ul class="dropdown-menu dropdown-menu-end p-3">
                        <li>
                          <a href="javascript:void(0);" class="dropdown-item rounded-1"
                            >Recently Added</a
                          >
                        </li>
                        <li>
                          <a href="javascript:void(0);" class="dropdown-item rounded-1"
                            >Ascending</a
                          >
                        </li>
                        <li>
                          <a href="javascript:void(0);" class="dropdown-item rounded-1"
                            >Desending</a
                          >
                        </li>
                        <li>
                          <a href="javascript:void(0);" class="dropdown-item rounded-1"
                            >Last Month</a
                          >
                        </li>
                        <li>
                          <a href="javascript:void(0);" class="dropdown-item rounded-1"
                            >Last 7 Days</a
                          >
                        </li>
                      </ul>
                    </div>
                    <a
                      href="javascript:void(0);"
                      class="d-inline-flex align-items-center text-primary fw-medium"
                      data-bs-toggle="modal"
                      data-bs-target="#add_notes"
                    >
                      <i class="ti ti-circle-plus me-1"></i>
                      Add Note
                    </a>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="border rounded p-3 mb-3">
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-md avatar-rounded flex-shrink-0 me-2">
                        <img src="assets/img/profiles/avatar-02.jpg" alt="Img" />
                      </span>
                      <div>
                        <h6 class="fw-medium mb-1">Darlee Robertson</h6>
                        <span>15 Sep 2023, 12:10 pm</span>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm"
                        ><i class="ti ti-edit"></i
                      ></a>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm"
                        ><i class="ti ti-trash"></i
                      ></a>
                    </div>
                  </div>
                  <div>
                    <h6 class="fw-medium mb-2">Notes added by Antony</h6>
                    <p class="mb-3">
                      A project review evaluates the success of an initiative and identifies areas
                      for improvement. It can also evaluate a current project to determine whether
                      it's on the right track. Or, it can determine the success of a completed
                      project.
                    </p>
                    <div class="d-flex align-items-center flex-wrap gap-3 mb-3">
                      <div
                        class="border rounded d-flex align-items-center justify-content-between hover-border p-3"
                      >
                        <div class="d-flex align-items-center me-4">
                          <span
                            class="avatar avatar-lg bg-success avatar-rounded flex-shrink-0 me-2"
                          >
                            <i class="ti ti-file-type-xls fs-24"></i>
                          </span>
                          <div>
                            <h6 class="fw-medium">Project Specs.xls</h6>
                            <span>365 KB</span>
                          </div>
                        </div>
                        <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-16"
                          ><i class="ti ti-download"></i
                        ></a>
                      </div>
                      <div
                        class="border rounded d-flex align-items-center justify-content-between hover-border p-3"
                      >
                        <div class="d-flex align-items-center me-4">
                          <span
                            class="avatar avatar-lg bg-success avatar-rounded flex-shrink-0 me-2"
                          >
                            <i class="ti ti-file-type-xls fs-24"></i>
                          </span>
                          <div>
                            <h6 class="fw-medium">090224.jpg</h6>
                            <span>365 KB</span>
                          </div>
                        </div>
                        <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-16"
                          ><i class="ti ti-download"></i
                        ></a>
                      </div>
                    </div>
                    <div class="notes-editor">
                      <div class="note-edit-wrap">
                        <div class="mb-3">
                          <div class="summernote">
                            Write a new comment, send your team notification by typing &#64;
                            followed by their name
                          </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-end mb-3">
                          <a
                            href="javascript:void(0);"
                            class="btn btn-outline-light border add-cancel me-3"
                            >Cancel</a
                          >
                          <a href="javascript:void(0);" class="btn btn-primary">Save</a>
                        </div>
                      </div>
                      <div>
                        <a
                          href="javascript:void(0);"
                          class="d-flex align-items-center justify-content-end text-primary fw-medium add-comment"
                        >
                          <i class="ti ti-circle-plus me-1"></i>
                          Add Comment
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="border rounded p-3 mb-3">
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-md avatar-rounded flex-shrink-0 me-2">
                        <img src="assets/img/profiles/avatar-03.jpg" alt="Img" />
                      </span>
                      <div>
                        <h6 class="fw-medium mb-1">Sharon Roy</h6>
                        <span>18 Sep 2023, 09:52 am</span>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm"
                        ><i class="ti ti-edit"></i
                      ></a>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm"
                        ><i class="ti ti-trash"></i
                      ></a>
                    </div>
                  </div>
                  <div>
                    <h6 class="fw-medium mb-2">Notes added by Antony</h6>
                    <p class="mb-3">
                      A project plan typically contains a list of the essential elements of a
                      project, such as stakeholders, scope, timelines, estimated cost and
                      communication methods. The project manager typically lists the information
                      based on the assignment.
                    </p>
                    <div class="d-flex align-items-center flex-wrap gap-3 mb-3">
                      <div
                        class="border rounded d-flex align-items-center justify-content-between hover-border p-3"
                      >
                        <div class="d-flex align-items-center me-4">
                          <span
                            class="avatar avatar-lg bg-purple avatar-rounded flex-shrink-0 me-2"
                          >
                            <i class="ti ti-file-description fs-24"></i>
                          </span>
                          <div>
                            <h6 class="fw-medium">Andrewpass.txt</h6>
                            <span>365 KB</span>
                          </div>
                        </div>
                        <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-16"
                          ><i class="ti ti-download"></i
                        ></a>
                      </div>
                    </div>
                    <div class="bg-light-500 rounded p-3 mb-3">
                      <p class="mb-2">
                        The best way to get a project done faster is to start sooner. A goal without
                        a timeline is just a dream.The goal you set must be challenging. At the same
                        time, it should be realistic and attainable, not impossible to reach.
                      </p>
                      <p class="text-dark mb-2">
                        Commented by <span class="text-primary"> Aeron</span> on 15 Sep 2023, 11:15
                        pm
                      </p>
                      <a
                        href="javascript:void(0);"
                        class="btn btn-dark d-inline-flex align-items-center"
                        ><i class="ti ti-arrow-back-up me-1"></i>Reply</a
                      >
                    </div>
                    <div class="notes-editor">
                      <div class="note-edit-wrap">
                        <div class="mb-3">
                          <div class="summernote">
                            Write a new comment, send your team notification by typing &#64;
                            followed by their name
                          </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-end mb-3">
                          <a
                            href="javascript:void(0);"
                            class="btn btn-outline-light border add-cancel me-3"
                            >Cancel</a
                          >
                          <a href="javascript:void(0);" class="btn btn-primary">Save</a>
                        </div>
                      </div>
                      <div>
                        <a
                          href="javascript:void(0);"
                          class="d-flex align-items-center justify-content-end text-primary fw-medium add-comment"
                        >
                          <i class="ti ti-circle-plus me-1"></i>
                          Add Comment
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="border rounded p-3 mb-3">
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-md avatar-rounded flex-shrink-0 me-2">
                        <img src="../../../../assets/img/profiles/avatar-03.jpg" alt="Img" />
                      </span>
                      <div>
                        <h6 class="fw-medium mb-1">Vaughan Lewis</h6>
                        <span>20 Sep 2023, 10:26 pm</span>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm"
                        ><i class="ti ti-edit"></i
                      ></a>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm"
                        ><i class="ti ti-trash"></i
                      ></a>
                    </div>
                  </div>
                  <div>
                    <h6 class="fw-medium mb-2">Notes added by Antony</h6>
                    <p class="mb-3">
                      Projects play a crucial role in the success of organizations, and their
                      importance cannot be overstated. Whether it's launching a new product,
                      improving an existing
                    </p>
                    <div class="notes-editor">
                      <div class="note-edit-wrap">
                        <div class="mb-3">
                          <div class="summernote">
                            Write a new comment, send your team notification by typing &#64;
                            followed by their name
                          </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-end mb-3">
                          <a
                            href="javascript:void(0);"
                            class="btn btn-outline-light border add-cancel me-3"
                            >Cancel</a
                          >
                          <a href="javascript:void(0);" class="btn btn-primary">Save</a>
                        </div>
                      </div>
                      <div>
                        <a
                          href="javascript:void(0);"
                          class="d-flex align-items-center justify-content-end text-primary fw-medium add-comment"
                        >
                          <i class="ti ti-circle-plus me-1"></i>
                          Add Comment
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane" id="bottom-justified-tab3" role="tabpanel">
            <div class="card border-0">
              <div class="card-header">
                <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <h5>Calls</h5>
                  <a
                    href="javascript:void(0);"
                    class="d-inline-flex align-items-center text-primary fw-medium"
                    data-bs-toggle="modal"
                    data-bs-target="#add_call"
                  >
                    <i class="ti ti-circle-plus me-1"></i>
                    Add New
                  </a>
                </div>
              </div>
              <div class="card-body">
                <div class="border rounded p-3 mb-3">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-3"
                  >
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-md avatar-rounded flex-shrink-0 me-2">
                        <img src="assets/img/profiles/avatar-02.jpg" alt="Img" />
                      </span>
                      <div>
                        <p class="fw-medium">
                          <span class="text-dark">Darlee Robertson </span> logged a call on 23 Jul
                          2023, 10:00 pm
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="dropdown me-2">
                        <a
                          href="#"
                          class="dropdown-toggle btn btn-sm bg-danger-transparent border-0"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          >Busy<i class="las la-angle-down ms-1"></i
                        ></a>
                        <div class="dropdown-menu dropdown-menu-end p-3">
                          <a class="dropdown-item rounded-1" href="javascript:void(0);">Busy</a>
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >No Answer</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Unavailable</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Wrong Number</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Left Voice Message</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Moving Forward</a
                          >
                        </div>
                      </div>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-trash"></i
                      ></a>
                    </div>
                  </div>
                  <div>
                    <p>
                      A project review evaluates the success of an initiative and identifies areas
                      for improvement. It can also evaluate a current project to determine whether
                      it's on the right track. Or, it can determine the success of a completed
                      project
                    </p>
                  </div>
                </div>
                <div class="border rounded p-3 mb-3">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-3"
                  >
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-md avatar-rounded flex-shrink-0 me-2">
                        <img src="assets/img/profiles/avatar-03.jpg" alt="Img" />
                      </span>
                      <div>
                        <p class="fw-medium">
                          <span class="text-dark">Sharon Roy </span> logged a call on 28 Jul 2023,
                          09:00 pm
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="dropdown me-2">
                        <a
                          href="#"
                          class="dropdown-toggle btn btn-sm bg-transparent-purple border-0"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          >No Answer<i class="las la-angle-down ms-1"></i
                        ></a>
                        <div class="dropdown-menu dropdown-menu-end p-3">
                          <a class="dropdown-item rounded-1" href="javascript:void(0);">Busy</a>
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >No Answer</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Unavailable</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Wrong Number</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Left Voice Message</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Moving Forward</a
                          >
                        </div>
                      </div>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-trash"></i
                      ></a>
                    </div>
                  </div>
                  <div>
                    <p>
                      A project plan typically contains a list of the essential elements of a
                      project, such as stakeholders, scope, timelines, estimated cost and
                      communication methods. The project manager typically lists the information
                      based on the assignment.
                    </p>
                  </div>
                </div>
                <div class="border rounded p-3">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-3"
                  >
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-md avatar-rounded flex-shrink-0 me-2">
                        <img src="../../../../assets/img/profiles/avatar-03.jpg" alt="Img" />
                      </span>
                      <div>
                        <p class="fw-medium">
                          <span class="text-dark">Vaughan Lewis </span> logged a call on 30 Jul
                          2023, 08:00 pm
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="dropdown me-2">
                        <a
                          href="#"
                          class="dropdown-toggle btn btn-sm bg-transparent-purple border-0"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          >No Answer<i class="las la-angle-down ms-1"></i
                        ></a>
                        <div class="dropdown-menu dropdown-menu-end p-3">
                          <a class="dropdown-item rounded-1" href="javascript:void(0);">Busy</a>
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >No Answer</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Unavailable</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Wrong Number</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Left Voice Message</a
                          >
                          <a class="dropdown-item rounded-1" href="javascript:void(0);"
                            >Moving Forward</a
                          >
                        </div>
                      </div>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-trash"></i
                      ></a>
                    </div>
                  </div>
                  <div>
                    <p>
                      Projects play a crucial role in the success of organizations, and their
                      importance cannot be overstated. Whether it's launching a new product,
                      improving an existing
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane" id="bottom-justified-tab4" role="tabpanel">
            <div class="card border-0">
              <div class="card-header">
                <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <h5>Files</h5>
                </div>
              </div>
              <div class="card-body">
                <div class="border rounded p-3 mb-3">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3"
                  >
                    <div>
                      <h6 class="fw-medium mb-1">Manage Documents</h6>
                      <p>
                        Send customizable quotes, proposals and contracts to close deals faster.
                      </p>
                    </div>
                    <div>
                      <a
                        href="#"
                        class="btn btn-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#create_file"
                        >Create Document</a
                      >
                    </div>
                  </div>
                </div>
                <div class="border rounded p-3 mb-3">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-2"
                  >
                    <div>
                      <h6 class="fw-medium mb-1">Collier-Turner Proposal</h6>
                      <p>
                        Send customizable quotes, proposals and contracts to close deals faster.
                      </p>
                    </div>
                    <div class="d-flex align-items-center">
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-download"></i
                      ></a>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-edit"></i
                      ></a>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-trash"></i
                      ></a>
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3"
                  >
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-md avatar-rounded flex-shrink-0 me-2">
                        <img src="assets/img/profiles/avatar-02.jpg" alt="Img" />
                      </span>
                      <div>
                        <span class="d-inline-flex mb-1">Owner</span>
                        <h6 class="fw-medium">Darlee Robertson</h6>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <span class="badge bg-pink-transparent me-2">Proposal</span>
                      <span class="badge badge-dark-transparent"
                        ><i class="ti ti-point-filled"></i>Proposal</span
                      >
                    </div>
                  </div>
                </div>
                <div class="border rounded p-3 mb-3">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-2"
                  >
                    <div>
                      <h6 class="fw-medium mb-1">Collier-Turner Proposal</h6>
                      <p>
                        Send customizable quotes, proposals and contracts to close deals faster.
                      </p>
                    </div>
                    <div class="d-flex align-items-center">
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-download"></i
                      ></a>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-edit"></i
                      ></a>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-trash"></i
                      ></a>
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3"
                  >
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-md avatar-rounded flex-shrink-0 me-2">
                        <img src="assets/img/profiles/avatar-01.jpg" alt="Img" />
                      </span>
                      <div>
                        <span class="d-inline-flex mb-1">Owner</span>
                        <h6 class="fw-medium">Sharon Roy</h6>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <span class="badge badge-soft-info me-2">Quote</span>
                      <span class="badge badge-soft-success"
                        ><i class="ti ti-point-filled"></i>Sent</span
                      >
                    </div>
                  </div>
                </div>
                <div class="border rounded p-3">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-2"
                  >
                    <div>
                      <h6 class="fw-medium mb-1">Collier-Turner Proposal</h6>
                      <p>
                        Send customizable quotes, proposals and contracts to close deals faster.
                      </p>
                    </div>
                    <div class="d-flex align-items-center">
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-download"></i
                      ></a>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-edit"></i
                      ></a>
                      <a href="javascript:void(0);" class="btn btn-icon btn-sm fs-20"
                        ><i class="ti ti-trash"></i
                      ></a>
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3"
                  >
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-md avatar-rounded flex-shrink-0 me-2">
                        <img src="../../../../assets/img/profiles/avatar-03.jpg" alt="Img" />
                      </span>
                      <div>
                        <span class="d-inline-flex mb-1">Owner</span>
                        <h6 class="fw-medium">Vaughan Lewis</h6>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <span class="badge bg-pink-transparent me-2">Proposal</span>
                      <span class="badge badge-dark-transparent"
                        ><i class="ti ti-point-filled"></i>Proposal</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane" id="bottom-justified-tab5" role="tabpanel">
            <div class="card border-0">
              <div class="card-header">
                <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <h5>Email</h5>
                </div>
              </div>
              <div class="card-body">
                <div class="border rounded p-3">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3"
                  >
                    <div>
                      <h6 class="fw-medium mb-1">Manage Emails</h6>
                      <p>You can send and reply to emails directly via this section.</p>
                    </div>
                    <div>
                      <a
                        href="#"
                        class="btn btn-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#connect_account"
                        >Connect Account</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addBusinessModal let-modal>
  <!-- <div class="modal custom-modal fade custom-modal-two modal-padding" id="add_company" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content"> -->
  <div class="modal-header header-border justify-content-between m-2">
    <h5 class="modal-title">Update Business Entity</h5>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="modal-body m-2">
    <div class="contact-grids-tab">
      <ul class="nav nav-underline" id="myTab" role="tablist">
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 1"
          (click)="stepChange(1)"
        >
          <!-- <span class="nav-link" [class.active]="currentStep === 1" >Owner Information</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 1"
            >Owner Information</a
          >
        </li>
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 2"
          (click)="stepChange(2)"
        >
          <!-- <span class="nav-link" [class.active]="currentStep === 2"  >Basic Information</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 2"
            >Basic Information</a
          >
        </li>
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 3"
          (click)="stepChange(3)"
        >
          <!-- <span class="nav-link" [class.active]="currentStep === 3"  >Address</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 3"
            >Address</a
          >
        </li>
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 4"
          (click)="stepChange(4)"
        >
          <!-- <span class="nav-link" [class.active]="currentStep === 4"  >Social Profiles</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 4"
            >Social Profiles</a
          >
        </li>
      </ul>
    </div>

    <div class="tab-content">
      <form [formGroup]="form" autocomplete="off" enctype="multipart/form-data">
        <div
          class="tab-pane"
          [ngClass]="{ 'show active': currentStep === 1, 'd-none': currentStep !== 1 }"
          id="owner-details"
          role="tabpanel"
          aria-labelledby="owner-details-tab"
          tabindex="0"
        >
          <!-- <div class="mb-4">
            <h5>Enter Business Owner Details</h5>
          </div> -->
          <fieldset *ngIf="currentStep === 1" id="first-field" formGroupName="ownerInfoForm">
            <div class="contact-input-set">
              <div class="row">
                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label" for="ownerId"
                      >Owner <span class="text-danger">*</span></label
                    >
                    <select class="form-select" formControlName="ownerId" id="ownerId">
                      <option value="" selected>Select</option>
                      <option *ngFor="let owner of userList" [value]="owner.id">
                        {{ owner.user.name | capitalize }}
                      </option>
                      <!-- <option>Guillory</option>
                      <option>Jami</option> -->
                    </select>
                    <div
                      *ngIf="
                        form.get('companyInfoForm')?.get('owner')?.invalid &&
                        form.get('companyInfoForm')?.get('owner')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getErrorMessage('companyInfoForm.owner') }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12 text-end form-wizard-button">
                  <button
                    type="button"
                    (click)="goToNextStep()"
                    [disabled]="!form.get('ownerInfoForm')?.valid"
                    class="btn btn-primary wizard-next-btn"
                  >
                    Save & Next
                  </button>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
        <!-- tab pane -->
        <div
          class="tab-pane"
          [ngClass]="{ 'show active': currentStep === 2, 'd-none': currentStep !== 2 }"
          id="company-details"
          role="tabpanel"
          aria-labelledby="company-details-tab"
          tabindex="0"
        >
          <div>
            <!-- <div class="mb-4">
              <h5>Enter Company Details</h5>
            </div> -->
            <fieldset *ngIf="currentStep === 2" formGroupName="companyInfoForm">
              <div class="col-md-12">
                <div
                  class="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4"
                >
                  <div
                    class="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames"
                  >
                    <i class="ti ti-photo text-gray-2 fs-16" *ngIf="!imageURL"></i>
                    <span
                      ><img
                        [src]="imageURL"
                        alt="Img"
                        *ngIf="imageURL"
                        class="img-fluid rounded-circle"
                    /></span>
                  </div>
                  <div class="profile-upload">
                    <div class="mb-2">
                      <h6 class="mb-1">Upload Profile Image</h6>
                      <!-- <p class="fs-12">Image should be below 4 mb</p> -->
                    </div>
                    <div class="profile-uploader d-flex align-items-center">
                      <div class="drag-upload-btn btn btn-sm btn-primary me-2">
                        Upload
                        <input
                          type="file"
                          class="form-control image-sign"
                          formControlName="picture"
                          (change)="onFileChange($event)"
                        />
                      </div>
                      <!-- <a href="javascript:void(0);" class="btn btn-light btn-sm">Cancel</a> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="contact-input-set">
                <div class="row">
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="businessName"
                        >Business Name <span class="text-danger"> *</span></label
                      >
                      <input formControlName="businessName" class="form-control" appTrimInput />
                      <div
                        *ngIf="
                          form.get('companyInfoForm')?.get('businessName')?.invalid &&
                          form.get('companyInfoForm')?.get('businessName')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('companyInfoForm.businessName') }}
                        </span>
                      </div>
                      <!-- Other fields for Basic Info here -->
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="website"
                        >Website <span class="text-danger"> *</span></label
                      >
                      <input
                        class="form-control"
                        type="text"
                        formControlName="website"
                        appTrimInput
                        type="url"
                      />
                      <div
                        *ngIf="
                          form.get('companyInfoForm')?.get('website')?.invalid &&
                          form.get('companyInfoForm')?.get('website')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('companyInfoForm.website') }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-12 text-end form-wizard-button">
                    <button
                      type="button"
                      (click)="stepChange(1)"
                      class="btn btn-secondary wizard-prev-btn me-3"
                      [disabled]="!form.get('companyInfoForm')?.valid"
                    >
                      Previous
                    </button>
                    <button
                      type="button"
                      (click)="goToNextStep()"
                      [disabled]="!form.get('companyInfoForm')?.valid"
                      class="btn btn-primary wizard-next-btn"
                    >
                      Save & Next
                    </button>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <!-- tab pane -->
        <div
          class="tab-pane"
          [ngClass]="{ 'show active': currentStep === 3, 'd-none': currentStep !== 3 }"
          id="address-detail"
          role="tabpanel"
          aria-labelledby="address-detail-tab"
          tabindex="0"
        >
          <div>
            <!-- <div class="mb-4">
              <h5>Address Details</h5>
            </div> -->
            <fieldset *ngIf="currentStep === 3" formGroupName="addressInfoForm">
              <div class="contact-input-set">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="address">Street Address *</label>
                      <input formControlName="address" class="form-control" appTrimInput />
                      <div
                        *ngIf="
                          form.get('addressInfoForm')?.get('address')?.invalid &&
                          form.get('addressInfoForm')?.get('address')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.address') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="country_id"
                        >Country <span class="text-danger">*</span></label
                      >
                      <select
                        class="form-select"
                        formControlName="country_id"
                        (change)="onChangeStateList($event.target)"
                      >
                        <option selected value="">Select Country</option>
                        <option *ngFor="let country of countryList" [value]="country.id">
                          {{ country.name }}
                        </option>
                        <!-- <option>US</option> -->
                      </select>

                      <div
                        *ngIf="
                          form.get('addressInfoForm')?.get('country_id')?.invalid &&
                          form.get('addressInfoForm')?.get('country_id')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.country_id') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="state_id"
                        >State / Province <span class="text-danger"> *</span></label
                      >
                      <!-- <input formControlName="state" class="form-control"> -->
                      <select
                        class="form-select"
                        formControlName="state_id"
                        (change)="onChangeCityList($event.target)"
                      >
                        <option selected value="">Select State</option>
                        <option *ngFor="let state of stateList" [value]="state.id">
                          {{ state.name }}
                        </option>
                        <!-- <option>US</option> -->
                      </select>
                      <div
                        *ngIf="
                          form.get('addressInfoForm')?.get('state_id')?.invalid &&
                          form.get('addressInfoForm')?.get('state_id')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.state_id') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="cityId"
                        >City <span class="text-danger"> *</span></label
                      >
                      <!-- <input formControlName="city" class="form-control"> -->
                      <select class="form-select" formControlName="cityId">
                        <option selected value="">Select City</option>
                        <option *ngFor="let city of cityList" [value]="city.id">
                          {{ city.name }}
                        </option>
                        <!-- <option>US</option> -->
                      </select>
                      <div
                        *ngIf="
                          form.get('addressInfoForm')?.get('cityId')?.invalid &&
                          form.get('addressInfoForm')?.get('cityId')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.cityId') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="zipCode"
                        >Postal Code <span class="text-danger"> *</span></label
                      >
                      <input formControlName="zipCode" class="form-control" appTrimInput />
                      <div
                        *ngIf="
                          form.get('addressInfoForm')?.get('zipCode')?.invalid &&
                          form.get('addressInfoForm')?.get('zipCode')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.zipCode') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- Other fields for Address here -->
                  <div class="col-lg-12 text-end form-wizard-button">
                    <button
                      type="button"
                      (click)="stepChange(2)"
                      class="btn btn-secondary wizard-prev-btn me-3"
                      [disabled]="!form.get('addressInfoForm')?.valid"
                    >
                      Previous
                    </button>
                    <button
                      type="button"
                      (click)="goToNextStep()"
                      [disabled]="!form.get('addressInfoForm')?.valid"
                      class="btn btn-primary wizard-next-btn"
                    >
                      Save & Next
                    </button>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <!-- tab pane -->

        <!-- tab pane -->
        <div
          class="tab-pane"
          [ngClass]="{ 'show active': currentStep === 4, 'd-none': currentStep !== 4 }"
          id="social-details"
          role="tabpanel"
          aria-labelledby="social-details-tab"
          tabindex="0"
        >
          <div>
            <div class="mb-4">
              <h5>Social</h5>
            </div>
            <fieldset *ngIf="currentStep === 4" formGroupName="socialInfoForm">
              <div class="contact-input-set">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="input-block mb-3">
                      <label for="Facebook">Facebook</label>
                      <input
                        formControlName="referenceIdFacebook"
                        appTrimInput
                        class="form-control"
                        type="url"
                      />
                      <div
                        *ngIf="
                          form.get('socialInfoForm')?.get('referenceIdFacebook')?.invalid &&
                          form.get('socialInfoForm')?.get('referenceIdFacebook')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('socialInfoForm.referenceIdFacebook') }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-12">
                    <div class="input-block mb-3">
                      <label for="Instagram">Instagram</label>
                      <input
                        formControlName="referenceIdInstagram"
                        appTrimInput
                        class="form-control"
                        type="url"
                      />
                      <div
                        *ngIf="
                          form.get('socialInfoForm')?.get('referenceIdInstagram')?.invalid &&
                          form.get('socialInfoForm')?.get('referenceIdInstagram')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('socialInfoForm.referenceIdInstagram') }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-12">
                    <div class="input-block mb-3">
                      <label for="LinkedIn">LinkedIn</label>
                      <input
                        formControlName="referenceIdLinkedIn"
                        appTrimInput
                        class="form-control"
                        type="url"
                      />
                      <div
                        *ngIf="
                          form.get('socialInfoForm')?.get('referenceIdLinkedIn')?.invalid &&
                          form.get('socialInfoForm')?.get('referenceIdLinkedIn')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('socialInfoForm.referenceIdLinkedIn') }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-12">
                    <div class="input-block mb-3">
                      <label for="twitter">Twitter</label>
                      <input
                        formControlName="referenceIdTwitter"
                        class="form-control"
                        type="url"
                        appTrimInput
                      />
                      <div
                        *ngIf="
                          form.get('socialInfoForm')?.get('referenceIdTwitter')?.invalid &&
                          form.get('socialInfoForm')?.get('referenceIdTwitter')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('socialInfoForm.referenceIdTwitter') }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-12">
                    <div class="input-block mb-3">
                      <label for="Whatsapp">Whatsapp</label>
                      <input
                        formControlName="referenceIdWhatsapp"
                        appTrimInput
                        class="form-control"
                        type="url"
                      />
                      <div
                        *ngIf="
                          form.get('socialInfoForm')?.get('referenceIdWhatsapp')?.invalid &&
                          form.get('socialInfoForm')?.get('referenceIdWhatsapp')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('socialInfoForm.referenceIdWhatsapp') }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-12">
                    <div class="input-block mb-3">
                      <label for="skype">Skype</label>
                      <input
                        formControlName="referenceIdSkype"
                        class="form-control"
                        type="url"
                        appTrimInput
                      />
                      <div
                        *ngIf="
                          form.get('socialInfoForm')?.get('referenceIdSkype')?.invalid &&
                          form.get('socialInfoForm')?.get('referenceIdSkype')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('socialInfoForm.referenceIdSkype') }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-12 text-end form-wizard-button">
                    <button
                      type="button"
                      (click)="stepChange(3)"
                      class="btn btn-secondary wizard-prev-btn me-3"
                      [disabled]="!form.get('socialInfoForm')?.valid"
                    >
                      Previous
                    </button>
                    <button
                      type="submit"
                      (click)="onSubmit()"
                      [disabled]="!form.get('socialInfoForm')?.valid"
                      class="btn btn-primary wizard-next-btn"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <!-- tab pane -->
      </form>
    </div>
    <!-- end tab content -->
  </div>
  <!-- </div>
      </div>
    </div> -->
</ng-template>

<ng-template #addOfficeModal let-modal>
  <!-- <div class="modal custom-modal fade custom-modal-two modal-padding" id="add_company" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content"> -->
  <div class="modal-header header-border justify-content-between m-2">
    <h5 class="modal-title">Add Office</h5>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="modal-body m-2">
    <div class="contact-grids-tab">
      <ul class="nav nav-underline" id="myTab" role="tablist">
        <li class="nav-item" role="presentation" [class.active]="currentStep === 1">
          <!-- <span class="nav-link" [class.active]="currentStep === 1"  >Basic Information</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 1"
            >Basic Information</a
          >
        </li>
        <li class="nav-item" role="presentation" [class.active]="currentStep === 2">
          <!-- <span class="nav-link" [class.active]="currentStep === 2"  >Address</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 2"
            >Address</a
          >
        </li>
      </ul>
    </div>

    <div class="tab-content">
      <form [formGroup]="officeform" autocomplete="off" enctype="multipart/form-data">
        <!-- tab pane -->
        <div
          class="tab-pane"
          [ngClass]="{ 'show active': currentStep === 1, 'd-none': currentStep !== 1 }"
          id="office-details"
          role="tabpanel"
          aria-labelledby="office-details-tab"
          tabindex="0"
        >
          <div>
            <!-- <div class="mb-4">
              <h5>Enter Company Details</h5>
            </div> -->
            <fieldset *ngIf="currentStep === 1" formGroupName="companyInfoForm">
              <div class="contact-input-set">
                <div class="row">
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="officeName"
                        >Office Name <span class="text-danger"> *</span></label
                      >
                      <input formControlName="officeName" class="form-control" appTrimInput />
                      <div
                        *ngIf="
                          officeform.get('companyInfoForm')?.get('officeName')?.invalid &&
                          officeform.get('companyInfoForm')?.get('officeName')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('companyInfoForm.officeName') }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-12 text-end form-wizard-button">
                    <button
                      type="button"
                      (click)="goToNextOfficeStep()"
                      [disabled]="!officeform.get('companyInfoForm')?.valid"
                      class="btn btn-primary wizard-next-btn"
                    >
                      Save & Next
                    </button>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <!-- tab pane -->
        <div
          class="tab-pane"
          [ngClass]="{ 'show active': currentStep === 2, 'd-none': currentStep !== 2 }"
          id="address-detail"
          role="tabpanel"
          aria-labelledby="address-detail-tab"
          tabindex="0"
        >
          <div>
            <!-- <div class="mb-4">
              <h5>Address Details</h5>
            </div> -->
            <fieldset *ngIf="currentStep === 2" formGroupName="addressInfoForm">
              <div class="contact-input-set">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="input-block mb-3">
                      <label for="address">Street Address <span class="text-danger">*</span></label>
                      <input formControlName="address" class="form-control" appTrimInput />
                      <div
                        *ngIf="
                          officeform.get('addressInfoForm')?.get('address')?.invalid &&
                          officeform.get('addressInfoForm')?.get('address')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.address') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="country_id"
                        >Country <span class="text-danger">*</span></label
                      >
                      <select
                        class="form-select"
                        formControlName="country_id"
                        (change)="onChangeStateList($event.target)"
                      >
                        <option selected value="">Select Country</option>
                        <option *ngFor="let country of countryList" [value]="country.id">
                          {{ country.name }}
                        </option>
                        <!-- <option>US</option> -->
                      </select>

                      <div
                        *ngIf="
                          officeform.get('addressInfoForm')?.get('country_id')?.invalid &&
                          officeform.get('addressInfoForm')?.get('country_id')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.country_id') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="state_id"
                        >State / Province <span class="text-danger"> *</span></label
                      >
                      <!-- <input formControlName="state" class="form-control"> -->
                      <select
                        class="form-select"
                        formControlName="state_id"
                        (change)="onChangeCityList($event.target)"
                      >
                        <option selected value="">Select State</option>
                        <option *ngFor="let state of stateList" [value]="state.id">
                          {{ state.name }}
                        </option>
                        <!-- <option>US</option> -->
                      </select>
                      <div
                        *ngIf="
                          officeform.get('addressInfoForm')?.get('state_id')?.invalid &&
                          officeform.get('addressInfoForm')?.get('state_id')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.state_id') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="cityId"
                        >City <span class="text-danger"> *</span></label
                      >
                      <!-- <input formControlName="city" class="form-control"> -->
                      <select class="form-select" formControlName="cityId">
                        <option selected value="">Select City</option>
                        <option *ngFor="let city of cityList" [value]="city.id">
                          {{ city.name }}
                        </option>
                        <!-- <option>US</option> -->
                      </select>
                      <div
                        *ngIf="
                          officeform.get('addressInfoForm')?.get('cityId')?.invalid &&
                          officeform.get('addressInfoForm')?.get('cityId')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.cityId') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="zipCode"
                        >Postal Code <span class="text-danger"> *</span></label
                      >
                      <input formControlName="zipCode" class="form-control" appTrimInput />
                      <div
                        *ngIf="
                          officeform.get('addressInfoForm')?.get('zipCode')?.invalid &&
                          officeform.get('addressInfoForm')?.get('zipCode')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.zipCode') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- Other fields for Address here -->
                  <div class="col-lg-12 text-end form-wizard-button">
                    <button
                      type="button"
                      (click)="stepChange(1)"
                      class="btn btn-secondary wizard-prev-btn me-3"
                      [disabled]="!officeform.get('addressInfoForm')?.valid"
                    >
                      Previous
                    </button>
                    <button
                      type="button"
                      (click)="createOfficeAddress()"
                      [disabled]="!officeform.get('addressInfoForm')?.valid"
                      class="btn btn-primary wizard-next-btn"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <!-- tab pane -->
      </form>
    </div>
    <!-- end tab content -->
  </div>
  <!-- </div>
      </div>
    </div> -->
</ng-template>

<ng-template #updateOfficeModal let-modal>
  <!-- <div class="modal custom-modal fade custom-modal-two modal-padding" id="add_company" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content"> -->
  <div class="modal-header header-border justify-content-between m-2">
    <h5 class="modal-title">Update Office</h5>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="modal-body m-2">
    <div class="contact-grids-tab">
      <ul class="nav nav-underline" id="myTab" role="tablist">
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 1"
          (click)="stepChange(1)"
        >
          <!-- <span class="nav-link" [class.active]="currentStep === 1"  >Basic Information</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 1"
            >Basic Information</a
          >
        </li>
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 2"
          (click)="stepChange(2)"
        >
          <!-- <span class="nav-link" [class.active]="currentStep === 2"  >Address</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 2"
            >Address</a
          >
        </li>
      </ul>
    </div>

    <div class="tab-content">
      <form [formGroup]="Updateofficeform" autocomplete="off" enctype="multipart/form-data">
        <!-- tab pane -->
        <div
          class="tab-pane"
          [ngClass]="{ 'show active': currentStep === 1, 'd-none': currentStep !== 1 }"
          id="office-details"
          role="tabpanel"
          aria-labelledby="office-details-tab"
          tabindex="0"
        >
          <div>
            <!-- <div class="mb-4">
              <h5>Enter Company Details</h5>
            </div> -->
            <fieldset
              *ngIf="currentStep === 1"
              formGroupName="companyInfoForm"
              class="show-fieldset"
            >
              <div class="contact-input-set">
                <div class="row">
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="officeName"
                        >Office Name <span class="text-danger"> *</span></label
                      >
                      <input formControlName="officeName" class="form-control" appTrimInput />
                      <div
                        *ngIf="
                          Updateofficeform.get('companyInfoForm')?.get('officeName')?.invalid &&
                          Updateofficeform.get('companyInfoForm')?.get('officeName')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('companyInfoForm.officeName') }}
                        </span>
                      </div>
                      <!-- Other fields for Basic Info here -->
                    </div>
                  </div>

                  <div class="col-lg-12 text-end form-wizard-button">
                    <button
                      type="button"
                      (click)="goToNextOfficeupdateStep()"
                      [disabled]="!Updateofficeform.get('companyInfoForm')?.valid"
                      class="btn btn-primary wizard-next-btn"
                    >
                      Save & Next
                    </button>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <!-- tab pane -->
        <div
          class="tab-pane"
          [ngClass]="{ 'show active': currentStep === 2, 'd-none': currentStep !== 2 }"
          id="address-detail"
          role="tabpanel"
          aria-labelledby="address-detail-tab"
          tabindex="0"
        >
          <div>
            <!-- <div class="mb-4">
              <h5>Address Details</h5>
            </div> -->
            <fieldset
              *ngIf="currentStep === 2"
              formGroupName="addressInfoForm"
              class="show-fieldset"
            >
              <div class="contact-input-set">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="address"
                        >Street Address <span class="text-danger">*</span></label
                      >
                      <input formControlName="address" class="form-control" appTrimInput />
                      <div
                        *ngIf="
                          Updateofficeform.get('addressInfoForm')?.get('address')?.invalid &&
                          Updateofficeform.get('addressInfoForm')?.get('address')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.address') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="country_id"
                        >Country <span class="text-danger">*</span></label
                      >
                      <select
                        class="form-select"
                        formControlName="country_id"
                        (change)="onChangeStateList($event.target)"
                      >
                        <option selected value="">Select Country</option>
                        <option *ngFor="let country of countryList" [value]="country.id">
                          {{ country.name }}
                        </option>
                        <!-- <option>US</option> -->
                      </select>

                      <div
                        *ngIf="
                          Updateofficeform.get('addressInfoForm')?.get('country_id')?.invalid &&
                          Updateofficeform.get('addressInfoForm')?.get('country_id')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.country_id') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="state_id"
                        >State / Province <span class="text-danger"> *</span></label
                      >
                      <!-- <input formControlName="state" class="form-control"> -->
                      <select
                        class="form-select"
                        formControlName="state_id"
                        (change)="onChangeCityList($event.target)"
                      >
                        <option selected value="">Select State</option>
                        <option *ngFor="let state of stateList" [value]="state.id">
                          {{ state.name }}
                        </option>
                        <!-- <option>US</option> -->
                      </select>
                      <div
                        *ngIf="
                          Updateofficeform.get('addressInfoForm')?.get('state_id')?.invalid &&
                          Updateofficeform.get('addressInfoForm')?.get('state_id')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.state_id') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="cityId"
                        >City <span class="text-danger"> *</span></label
                      >
                      <!-- <input formControlName="city" class="form-control"> -->
                      <select class="form-select" formControlName="cityId">
                        <option selected value="">Select City</option>
                        <option *ngFor="let city of cityList" [value]="city.id">
                          {{ city.name }}
                        </option>
                        <!-- <option>US</option> -->
                      </select>
                      <div
                        *ngIf="
                          Updateofficeform.get('addressInfoForm')?.get('cityId')?.invalid &&
                          Updateofficeform.get('addressInfoForm')?.get('cityId')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.cityId') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label" for="zipCode"
                        >Postal Code <span class="text-danger"> *</span></label
                      >
                      <input formControlName="zipCode" class="form-control" appTrimInput />
                      <div
                        *ngIf="
                          Updateofficeform.get('addressInfoForm')?.get('zipCode')?.invalid &&
                          Updateofficeform.get('addressInfoForm')?.get('zipCode')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('addressInfoForm.zipCode') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- Other fields for Address here -->
                  <div class="col-lg-12 text-end form-wizard-button">
                    <!-- <button
                      type="button"
                      (click)="stepChange(1)"
                      class="btn btn-secondary wizard-prev-btn me-3"
                      [disabled]="!Updateofficeform.get('addressInfoForm')?.valid"
                    > -->
                    <button
                      type="button"
                      (click)="stepChange(1)"
                      class="btn btn-secondary wizard-prev-btn me-3"
                    >
                      Previous
                    </button>
                    <button
                      type="button"
                      (click)="createOfficeAddress()"
                      [disabled]="!Updateofficeform.get('addressInfoForm')?.valid"
                      class="btn btn-primary wizard-next-btn"
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <!-- tab pane -->
      </form>
    </div>
    <!-- end tab content -->
  </div>
  <!-- </div>
      </div>
    </div> -->
</ng-template>
